// external
import { Box, LinearProgress } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useService from '../../../hooks/service.hook';
import useSnackbarHelper from '../../../hooks/snackbar.hook';
import DeviceRegistrationService from '../../../services/device-registration.service';

const GarminOAuthRedirectPage: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbarHelper();
  const deviceRegistrationService = useService(DeviceRegistrationService);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const oauthToken = searchParams.get('oauth_token');
    const oauthVerifierCode = searchParams.get('oauth_verifier');

    if (oauthToken && oauthVerifierCode) {
      deviceRegistrationService
        .registerGarminUser(oauthVerifierCode)
        .then(() => {
          showSnackbar('Successfully synced Garmin with your CoeLab account', 'success');
          navigate('/profile');
        })
        .catch(() => {
          showSnackbar(
            'There was an error while syncing Garmin with your CoeLab account. Please try again later.',
            'error'
          );
          navigate('/profile');
        });
    } else {
      showSnackbar(
        'There was an error while syncing Garmin with your CoeLab account. Please try again later.',
        'error'
      );
      navigate('/profile');
    }
  }, [location.search]);

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: window.innerHeight,
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <h1>Syncing Garmin to your CoeLab account...</h1>
      <Box sx={{ width: '70%', margin: 5 }}>
        <LinearProgress />
        <LinearProgress />
        <LinearProgress />
      </Box>
    </div>
  );
};

export default GarminOAuthRedirectPage;
